module.exports = __webpack_public_path__ + "static/media/cicek4.eec3242f.jpg";